import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { PaymentFilters } from '../../../commons/models/payment.model';

@Component({
  selector: 'app-payment-filters',
  templateUrl: './payment-filters.component.html',
  styleUrls: ['./payment-filters.component.scss']
})
export class PaymentFiltersComponent {
  @Output()
  onFilter: EventEmitter<PaymentFilters> = new EventEmitter();

  private _defaultFilters: PaymentFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this._createForm();
  }

  private _createForm() {
    let group = {
      search: "",
    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getPayment());
  }

  private _getPayment(): PaymentFilters {
    let filters: PaymentFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      filters.search = values.search;
    }
    return filters;
  }

  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      search: "",
    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): PaymentFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: PaymentFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          search: this.defaultFilters.search,
        })
      }
    }
  }
}
